import React, { FC, memo } from 'react'
import { CommunicationItem, CommunicationWrapper } from './styles'
import { FormattedContactDetails, CommunicationTypes } from '../../../models/property-details-page/contact-model'
import { Typography } from 'react-components'
import isEmpty from 'lodash/isEmpty'

import { FaxIcon, PhoneIcon, TelephoneIcon } from '../../common/icons'

interface CommunicationListProps {
    communications: FormattedContactDetails['communication']
}

const CommunicationList: FC<CommunicationListProps> = ({ communications }) => {
    if (isEmpty(communications)) {
        return null
    }

    return (
        <CommunicationWrapper>
            {communications?.map((comm, index) => {
                const type = Number(comm.type)
                if (type !== CommunicationTypes.COMMUNICATION_EMAIL) {
                    return (
                        <CommunicationItem key={`${comm.value}-${index}`}>
                            {type === CommunicationTypes.COMMUNICATION_MOBILE && <PhoneIcon />}
                            {type === CommunicationTypes.COMMUNICATION_FAX && <FaxIcon />}
                            {type === CommunicationTypes.COMMUNICATION_PHONE && <TelephoneIcon />}
                            <Typography variant="subtitle2" color="tfwBlack40">
                                {comm.value}
                            </Typography>
                        </CommunicationItem>
                    )
                }
                return null
            })}
        </CommunicationWrapper>
    )
}

export default memo(CommunicationList)
